const processPayNowStatus = ({ status }: { status: string }) => {
  const endpointParams: Record<
    'status' | 'refundStatus' | 'shippingStatus' | 'excludedRefundStatus',
    string
  > = {
    status: '',
    refundStatus: '',
    shippingStatus: '',
    excludedRefundStatus: '',
  };
  switch (status) {
    case 'ALL':
      endpointParams.status = 'CONFIRMED,COMPLETED';
      break;
    case 'COMPLETED':
      endpointParams.status = 'COMPLETED';
      endpointParams.shippingStatus = 'DISPATCHED';
      endpointParams.excludedRefundStatus = 'REFUNDED';
      break;
    case 'REFUNDED':
      endpointParams.status = 'COMPLETED';
      endpointParams.refundStatus = 'REFUNDED';
      break;
    default:
      endpointParams.status = status;
      break;
  }

  return endpointParams;
};

const getFormattedPayNowStatus = ({ item }: { item: any }) => {
  let status = item.orderStatus;
  if (status === 'COMPLETED' && item.refundStatus === 'REFUNDED') {
    return item.refundStatus;
  }
  if (['CONFIRMED'].includes(status) && item.shippingStatus === 'DISPATCHED') {
    return 'DISPATCHED';
  }
  if (['COMPLETED', 'CONFIRMED'].includes(status)) {
    return status;
  }
  if (item.refundStatus) {
    status = item.refundStatus;
  } else if (item.shippingStatus === 'DISPATCHED') {
    status = item.shippingStatus;
  }
  return status;
};

export { processPayNowStatus, getFormattedPayNowStatus };
